import Ajax from '@utils/ajax';

export default {
  stepOne(modalId, keyword, groupId, options = {}) {
    return Ajax.post({
      url: `/autofill_stats/step_one`,
      data: {
        modal_id: modalId,
        keyword: keyword,
        group_base_id: groupId,
      },
      ...options,
    });
  },

  stepTwo(modalId, keyword, groupId, options = {}) {
    return Ajax.post({
      url: `/autofill_stats/step_two`,
      data: {
        modal_id: modalId,
        keyword: keyword,
        group_base_id: groupId,
      },
      ...options,
    });
  },

  stepThree(modalId, recObjectId, options = {}) {
    return Ajax.post({
      url: `/autofill_stats/step_three`,
      data: {
        modal_id: modalId,
        rec_object_id: recObjectId,
      },
      ...options,
    });
  },
};
